import './index.scss';
import React from 'react';
import ImageClass from './icon/icon-class.png';
import ImageGroup from './icon/icon-group.png';
import ImageDepartmentYellow from './icon/icon-department-yellow.png';
import { Tooltip } from '@umu/umu-design';
import { getUserAvatarStyle, overlayInnerStyle } from './dataFlow';
import { IAccountInfo, MEMBER_TYPE } from '../../interface/account';
import UserAvatar from '../../../user/userAvatar/userAvatar';
import { If } from 'common/src/components';

interface IProps {
    prefixCls?: string;
    id: string;
    type: MEMBER_TYPE;
    avatar: string;
    userLevel: string;
    name: string;
    showUserLevel: string;
    className?: string;
    avatarWidth?: number;
    splitCount?: number;
    suffixElement?: React.ReactNode | string;
}

const MemberDetailInfo = (props: IProps) => {
    const {
        type,
        prefixCls = 'permission-member-info',
        avatar = '',
        showUserLevel,
        userLevel,
        name = '',
        id = '',
        className = '',
        suffixElement = '',
        splitCount = 40,
        avatarWidth = 32,
    } = props;
    const memberLabel = name || '';
    let memberAvatar = avatar;
    if (type === MEMBER_TYPE.CLASS) {
        memberAvatar = ImageClass;
    }
    if (type === MEMBER_TYPE.GROUP) {
        memberAvatar = ImageGroup;
    }
    if (type === MEMBER_TYPE.DEPARTMENT) {
        memberAvatar = ImageDepartmentYellow;
    }

    return (
        <div className={`${prefixCls} ${className} flex--1`}>
            <If condition={!!memberAvatar}>
                <UserAvatar
                    src={memberAvatar}
                    width={avatarWidth}
                    className={`${prefixCls}-avatar ${className}-avatar`}
                    showUserLevel={Number(showUserLevel)}
                    userLevelInfo={Number(userLevel)}
                />
            </If>
            <If condition={!memberAvatar}>
                <div className={`${prefixCls}-member-label`} style={getUserAvatarStyle(avatarWidth, id)}>
                    {((memberLabel && memberLabel[0]) || '').toLowerCase() || 'U'}
                </div>
            </If>
            <Tooltip
                title={memberLabel.length > splitCount ? memberLabel : ''}
                placement="bottom"
                color="#ffffff"
                zIndex={9999}
                overlayInnerStyle={overlayInnerStyle}
            >
                <div className={`${prefixCls}-member-info flex--1`}>
                    <div className={`${prefixCls}-member-info-label`}>{memberLabel}</div>
                    {suffixElement}
                </div>
            </Tooltip>
        </div>
    );
};
const onTransformMenuList = (list: IAccountInfo[], actType?: string) => {
    if (actType) {
        return list.map((item) => {
            return {
                key: `${item.id}-${actType}`,
                title: (
                    <MemberDetailInfo
                        id={item.id}
                        type={actType as MEMBER_TYPE}
                        avatar={item?.avatar || ''}
                        userLevel={item?.user_level || ''}
                        name={item?.name || item.login_name || ''}
                        showUserLevel={item?.show_user_level || ''}
                    />
                ),
                info: item,
            };
        });
    }
    return list.map((item) => {
        return {
            key: `${item.id}-${item.account_type}`,
            info: item,
            title: (
                <MemberDetailInfo
                    id={item.id}
                    type={item.account_type}
                    avatar={item.avatar}
                    userLevel={item?.user_level || ''}
                    name={item.account || item.name || item.login_name || ''}
                    showUserLevel={item?.show_user_level || ''}
                />
            ),
        };
    });
};
export { MemberDetailInfo, onTransformMenuList };
